// population.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const usePopulationStore = defineStore('population', {
    state: () => ({
        allPopulation: [],
        populationList: [],

        name: [],
    }),
    actions: {
        async getPopulation(filter) {
            try {
                const response = await axios.get('/population', { params: filter })
                if (response.status === 200) {
                    this.populationList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
       async autoCompletePopulationName(filter) {
            try {
                const { status, data } = await axios.get('/population/search', { params: filter, noLoader: true   });

                // รองรับทั้ง paginate และไม่ paginate
                const list =
                Array.isArray(data?.data?.data) ? data.data.data :
                Array.isArray(data?.data)       ? data.data :
                Array.isArray(data)             ? data :
                [];

                
                return list; // >>> ส่ง array กลับเสมอ
            } catch (e) {
                console.error('error:', e);
                return []; // กันพังฝั่ง caller
            }
        },
        async getPopulationById(id) {
            try {
                const response = await axios.get(`/population/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createPopulation(body) {
            try {
                const response = await axios.post('/population', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updatePopulation(id, body) {
            try {
                const response = await axios.post(`/population/${id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async transferPopulation(id, body) {
            try {
                const response = await axios.post(`/population/transfer/${id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async exitPopulation(id, body) {
            try {
                const response = await axios.post(`/population/exit/${id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async exitAllPopulation(body) {
            try {
                const response = await axios.post(`/population-exit-all`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async checkNamePopulation(body) {
            try {
                const response = await axios.post(`/population-check`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
